<template>
  <div>
    <d-table
      v-if="tableReady"
      :data_object="data_object"
      :getFreshData="true"
      :linkClick="linkClick"
      :link="link"
      :mobileBreakpoint="'0'"
      :itemsPerPage="15"
      :hasSearch="true"
      ref="dTable"
      :key="tableKey"
      :serverPagination="false"
      :showGroupBy="false"
      :sortBy="sortBy"
      :sortDesc="true"
      :insertable="false"
      :editRow="true"
      :addButtonCaption="addButtonCaption"
      :alwaysUpdate="true"
      :onDataReceived="onDataReceived"
      :editedItemTitle="editedItemTitle"
      tableName="brokers"
      :columnTool="true"
      :noRefreshAfterUpload="true"
    />
  </div>
</template>

<script>
import * as fun from "../plugins/common";
export default {
  name: "Agents",
  components: {
    DTable: () => import("../components/Table.vue"),
  },
  props: {},
  data() {
    return {
      tableKey: 0,
      tableReady: true,
      getFreshData: true,
      data_object: {
        object_name: "broker",
        table_title: "Brokers",
        all_records: true,
      },
      editedItemTitle: ["full_name"],
      searchableColumns: [],
      sortBy: "full_name",

      addButtonCaption: "Add Broker",
    };
  },
  mounted() {},

  methods: {
    onDataReceived(d) {
      return d;
    },
  },
};
</script>

<style lang="css" scoped></style>
